import fa from './fa.json';
import en from './en.json';

export const dictionaries = {
  fa,
  en
};

const localeByLanguage = {
  fa: 'fa-IR',
  en: 'en-US'
};

const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

export const getLocale = (language) => localeByLanguage[language] || localeByLanguage.en;

export const localizeDigits = (value, language) => {
  const stringValue = String(value ?? '');

  if (language !== 'fa') {
    return stringValue;
  }

  return stringValue.replace(/\d/g, (digit) => persianDigits[Number(digit)]);
};

export const translate = (language, key, params = {}) => {
  const template = dictionaries[language]?.[key] || dictionaries.en[key] || key;

  if (typeof template !== 'string') {
    return template;
  }

  const translatedMessage = Object.entries(params).reduce((message, [paramKey, value]) => {
    return message.replace(new RegExp(`{{${paramKey}}}`, 'g'), localizeDigits(value, language));
  }, template);

  return localizeDigits(translatedMessage, language);
};
